module.exports = __webpack_public_path__ + "img/ps-30.845ab5bf.jpg";